import React from "react"


const CopyRight = props => {
    return (
      <div className="app-footer">
        &copy; {new Date().getFullYear()} Claima Technologies
      </div>
    )
}


export default CopyRight
